<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Authors’ Note</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">THIS IS</span> book 2 in the <span style=" font-style: italic; font-size: 1.00em;">Crossing Nuwa</span> series. This series occurs in the Crimson Paradigm world and the <span style=" font-style: italic; font-size: 1.00em;">Darklight</span> series (Ninestar Press) has Robbie and Theo as cameo characters. Thank you so much for taking the time to enjoy our work. Please visit us at www.dreamersworkshop.com to find out more about the characters and timelines.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?269dd206